// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"Hero-module--mainHeading--30vIR","isHomepage":"Hero-module--isHomepage--1VM8C"};